import { Button } from "@instacover/ui"
// TODO placeholder icon — replace with the icon provided by design
import { IconChevronRight } from "@tabler/icons-react"
import { createFileRoute, Link } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { BaseLayout } from "@/components/layouts/BaseLayout"
import { SpinnerLayout } from "@/components/layouts/SpinnerLayout"
import { UniversalImage } from "@/components/UniversalImage"
import { LINKS } from "@/routing/links"
import { type PhotoSlim, usePhotosByStepType } from "@/services/dexie"

export const Route = createFileRoute("/$sessionId/_session/claim/photos/select")({
  component: ClaimPhotoSelectPage,
})

function ClaimPhotoSelectPage() {
  const { sessionId } = Route.useParams()

  const { t } = useTranslation()

  const { data: photos, isLoading } = usePhotosByStepType(sessionId, "Claim")
  const photoList = photos ?? []

  if (isLoading || photoList.length === 0) {
    return <SpinnerLayout />
  }

  return (
    <BaseLayout dataTestId="claim-photo-select">
      <div className="h-vh-header relative mx-auto flex max-w-2xl flex-col px-6 pt-8 pb-6">
        <div className="min-h-0 flex-1 overflow-y-auto">
          <h1 className="text-ic-heading text-2xl font-bold">{t("claim.photoSelect.heading")}</h1>
          <p className="text-ic-text mt-4 text-base">{t("claim.photoSelect.description")}</p>

          <ul className="mt-6 flex flex-col gap-4" data-testid="photo-select-items-wrapper">
            {photoList.map((photo) => (
              <li key={photo.id} data-testid="photo-select-item">
                <PhotoSelectItem sessionId={sessionId} photo={photo} />
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-6 flex shrink-0 flex-col gap-3">
          <Link to={LINKS.claimNew(sessionId)}>
            <Button data-testid="photo-select-new-photo-btn">{t("claim.photoSelect.buttonNew")}</Button>
          </Link>

          <Link to={LINKS.claimOverview(sessionId)}>
            <Button variant="secondary" data-testid="photo-select-back-btn">
              {t("claim.photoSelect.buttonBack")}
            </Button>
          </Link>
        </div>
      </div>
    </BaseLayout>
  )
}

function PhotoSelectItem(props: { sessionId: string; photo: PhotoSlim }) {
  const { sessionId, photo } = props
  const { t } = useTranslation()

  return (
    <Link
      to={LINKS.claimNewMarker(sessionId, photo.id)}
      className="border-ic-primary block overflow-hidden rounded-xl border border-solid"
    >
      <UniversalImage photo={photo} variant="full" className="h-40 w-full object-cover" />

      <div className="bg-ic-background flex items-center justify-between py-4 pr-4 pl-6">
        <span className="text-ic-primary text-base font-bold uppercase">{t("claim.photoSelect.buttonSelect")}</span>
        <IconChevronRight className="text-ic-primary size-6" />
      </div>
    </Link>
  )
}
